export const GB_FEATURES = {
  EXP_STICKY_EXPOSED_FILTERS_MOBILE: 'exp_sticky_exposed_filters_mobile',
  EXP_UPDATED_PUPPY_RESULTS_CARD: 'exp_updated_puppy_results_card'
};
